import React, {useEffect, useRef} from 'react';
import {clsx} from 'clsx';
import {ORDER_STATUS} from "../../constants";
import {useOrdersStore} from "../../store/orderStore";


export const OrderTabs = ({activeTab, onTabChange}) => {
  const {orderCountStatusAllTime} = useOrdersStore();
  const tabsContainerRef = useRef(null);
  const activeTabRef = useRef(null);
  const countAll = orderCountStatusAllTime?.sellerConfirm +
    orderCountStatusAllTime?.sellerPrepared +
    orderCountStatusAllTime?.shippingProcessing +
    orderCountStatusAllTime?.shippingDone +
    orderCountStatusAllTime?.orderCancel +
    orderCountStatusAllTime?.orderRefund;
  const countConfirm = orderCountStatusAllTime?.sellerConfirm + orderCountStatusAllTime?.sellerPrepared
  const tabs = [
    {id: 'all', label: 'Tất cả', count: countAll},
    {id: ORDER_STATUS.SELLER_CONFIRM, label: 'Chờ xác nhận', count: countConfirm},
    // {id: ORDER_STATUS.SELLER_PREPARED, label: 'Giao vận chuyển', count: orderCountStatusAllTime?.sellerPrepared},
    {id: ORDER_STATUS.SHIPPING_PROCESSING, label: 'Đang giao', count: orderCountStatusAllTime?.shippingProcessing},
    {id: ORDER_STATUS.SHIPPING_DONE, label: 'Giao thành công', count: orderCountStatusAllTime?.shippingDone},
    {id: ORDER_STATUS.ORDER_CANCEL, label: 'Huỷ', count: orderCountStatusAllTime?.orderCancel},
    {id: ORDER_STATUS.ORDER_REFUND, label: 'Hoàn/trả', count: orderCountStatusAllTime?.orderRefund},
  ];
  useEffect(() => {
    // Use setTimeout to ensure the DOM has been updated
    const timeoutId = setTimeout(() => {
      if (activeTabRef.current && tabsContainerRef.current) {
        const container = tabsContainerRef.current;
        const activeTabElement = activeTabRef.current;

        // Get the tab's position relative to the container
        const containerRect = container.getBoundingClientRect();
        const tabRect = activeTabElement.getBoundingClientRect();

        // Always scroll to position the active tab in the center
        const scrollLeft =
          tabRect.left +
          container.scrollLeft -
          containerRect.left -
          (containerRect.width / 2) +
          (tabRect.width / 2);

        container.scrollTo({
          left: Math.max(0, scrollLeft),
          behavior: 'smooth'
        });
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, [activeTab]);

  return (
    <div className="relative bg-white rounded-[5px] border-b border-gray-200 md:border-none">
      {/* Gradient overlay để hiển thị còn scroll */}
      <div
        className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none md:hidden"/>

      {/* Container chính với scroll */}
      <div ref={tabsContainerRef} className="overflow-x-auto scrollbar-hide">
        <div className="flex justify-around w-full border-b border-transparent px-4">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              ref={activeTab === tab.id ? activeTabRef : null}
              onClick={() => onTabChange(tab.id)}
              className={clsx(
                'px-2 py-4 md:py-2 md:p-2 -mb-px whitespace-nowrap text-sm transition-colors',
                activeTab === tab.id
                  ? 'border-b-2 border-[#197D55] font-bold text-[#197D55]'
                  : ' hover:text-gray-700'
              )}
            >
              {tab.label} {tab.count > 0 && `(${tab.count})`}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
